import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { token, user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center bg-[var(--apex-primary)]">
        <Loader2 className="animate-spin text-white" size={32} />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
